<template>
        <div class="pdf" v-show="fileType === 'pdf'" style="height:500px;overflow: auto;" id="pdf" v-loading="loading">
            <!-- <p class="arrow">
                <el-button size="small" type="primary" icon="el-icon-arrow-left" @click="changePdfPage(0)" :disabled='currentPage==1'>上一页</el-button>
                {{currentPage}} / {{pageCount}}
                <el-button size="small" type="primary" icon="el-icon-arrow-right"
                        @click="changePdfPage(1)"
                        :disabled='currentPage==pageCount'
                >下一页</el-button>
            </p> -->
            <pdf
                    :src="this.baseURL +
                      'httpfile.svt/wxarticle?token=' +
                      this.token +
                      '&fileName=' +
                      fileName+
                      '&keyId='+
                      uuid"
                    :page="currentPage"
                    style="width:100%;"
                    ref="print1"
                    @num-pages="pageCount=$event"
                    @page-loaded="currentPage=$event"
                    @loaded="loadPdfHandler"
            ></pdf>
        </div>
</template>

<script>
    import pdf from 'vue-pdf';
    import { devEnvironment, proEnvironment } from '@/assets/js/division';
    import { mapState } from 'vuex';
    import { ReportParam } from '@/service/ReportServiceMgeSvr/ReportParam.js';
    import { ReportServiceMgeSvr } from '@/service/ReportServiceMgeSvr/ReportServiceMgeSvr';
    export default {
        components: {pdf},
        computed:{
            ...mapState(['token']),
            baseURL() {
            let baseURL = '';
            if (process.env.NODE_ENV === 'development') {
                baseURL = devEnvironment;
            } else if (process.env.NODE_ENV === 'production') {
                baseURL = proEnvironment;
            }
            return baseURL;
    },
        },
        watch:{
            currentPage(val){
                this.$store.dispatch('SetCurrentPage',val)
            },
            pageCount(val){
                this.$store.dispatch('SetPageCount',val)
                if(!!val){
                    this.loading=false
                }else{
                    this.loading=true
                }
            }
        },
        props: {fileName:String,uuid:String},
        data() {
            return{
                currentPage: 0, // pdf文件页码
                pageCount: 0, // pdf文件总页数
                fileType: 'pdf', // 文件类型
                dialogVisiblePrint:false,
                pdfUrl:'',
                reportParam:new ReportParam(),
                reportServiceMgeSvr:new ReportServiceMgeSvr(),
                loading:false
            };
        },
        created(){   
        },
        mounted(){
            if(this.dialog){
                this.printRecord();
            }
            window.addEventListener("scroll", this.handleScroll, true);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods:{
            close(){
                this.$emit('isClose',false);
            },
            // pdf加载时
            loadPdfHandler (e) {
                this.currentPage = 1; // 加载的时候先加载第一页
            },
            changePdfPage(val) {
                if (val === 0 && this.currentPage > 1) {
                    this.currentPage--;
                }
                if (val === 1 && this.currentPage < this.pageCount) {
                    this.currentPage++;
                }
            },

            //下载
            download(res) {
                if (process.env.NODE_ENV === 'development') {
                    this.baseURL = devEnvironment;
                } else if (process.env.NODE_ENV === 'production') {
                    this.baseURL = proEnvironment;
                }
                const a = document.createElement('a'); // 创建a标签
                a.setAttribute('download', ''); // download属性
                a.setAttribute(
                    'href',
                    this.baseURL +
                    'download/file/' + res
                ); // href链接
                a.click(); // 自执行点击事件
            },
            gotop(){
                document.getElementById('pdf').scrollTop=0
                document.getElementById('pdf').scrollLeft=0
            }
        }
    };
</script>
